import { sendContactByEmail } from "./services/mail.service";
import { validateAndSendForm } from "./utils/form.util";

const rules = (inputs) => {
  const [nameInput, phoneInput, emailInput, messageInput] = inputs;
  return [
    {
      field: `${nameInput}`,
      rules: [
        { rule: "required", errorMessage: "Por favor, ingresa tu nombre." },
        {
          rule: "minLength",
          value: 3,
          errorMessage: "El nombre debe tener al menos 3 caracteres.",
        },
      ],
    },
    {
      field: `${phoneInput}`,
      rules: [
        { rule: "required", errorMessage: "El teléfono es obligatorio." },
        {
          rule: "customRegexp",
          value: /^[0-9]{10}$/,
          errorMessage: "Debe ser un número de 10 dígitos.",
        },
      ],
    },
    {
      field: `${emailInput}`,
      rules: [
        {
          rule: "required",
          errorMessage: "El correo electrónico es obligatorio.",
        },
        {
          rule: "email",
          errorMessage: "Ingresa un correo electrónico válido.",
        },
      ],
    },
    {
      field: `${messageInput}`,
      rules: [
        { rule: "required", errorMessage: "El mensaje no puede estar vacío." },
        {
          rule: "minLength",
          value: 10,
          errorMessage: "El mensaje debe tener al menos 10 caracteres.",
        },
      ],
    },
  ];
};

export const sendContactForm = (form) => {
  validateAndSendForm(form, rules, sendContactByEmail, (wasSendForm) => {});
};
